import { render, staticRenderFns } from "./ComponentListExtras.vue?vue&type=template&id=45fd83fa"
import script from "./ComponentListExtras.vue?vue&type=script&lang=js"
export * from "./ComponentListExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports